import { formatShortISO } from './utils';

// https://github.com/InteractionDesignFoundation/add-event-to-calendar-docs/blob/main/services/google.md
type CreateGCEventLinkParams = {
  text: string;
  dates: [start: Date, end: Date];
  details?: string;
  recur?: `RRULE:${string}`;
  location?: string;
  timeZone?: string;
  allDay?: boolean;
};

const gcOptionalParamsMap = {
  details: 'details',
  location: 'location',
  ctz: 'timeZone',
  recur: 'recur'
} as const;

export function createGCEventURL({
  text,
  dates,
  allDay,
  ...optionalParams
}: CreateGCEventLinkParams) {
  const url = new URL('https://calendar.google.com/calendar/render');

  url.searchParams.append('action', 'TEMPLATE');
  url.searchParams.append('text', text);
  url.searchParams.append(
    'dates',
    dates.map((date) => formatShortISO(date, allDay)).join('/')
  );

  Object.entries(gcOptionalParamsMap).forEach(([paramName, paramsKey]) => {
    if (optionalParams[paramsKey]) {
      url.searchParams.append(paramName, optionalParams[paramsKey]);
    }
  });

  return url.toString();
}
